import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

class CommunityCouncilService {

    getMvtUrlTemplate() {
        return `${API_BASE_URL}/mvt/community-councils/{z}/{x}/{y}`;
    }

    async getAllCommunityCouncilsGeoJson() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/community-councils/geojson`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error fetching community councils GeoJSON:', error);
            throw error;
        }
    }
}

export default new CommunityCouncilService();